import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @format */

/**
 * External dependencies
 */
import { __, _n, sprintf } from '@wordpress/i18n';
import classnames from 'classnames';
import { Component } from '@wordpress/element';
import { escapeRegExp, findIndex, identity, noop } from 'lodash';
import PropTypes from 'prop-types';
import { withFocusOutside, withSpokenMessages } from '@wordpress/components';
import { withInstanceId, compose } from '@wordpress/compose';
/**
 * Internal dependencies
 */

import List from './list';
import Tags from './tags';
import Control from './control';
/**
 * A search box which filters options while typing,
 * allowing a user to select from an option from a filtered list.
 */

export var SelectControl =
/*#__PURE__*/
function (_Component) {
  _inherits(SelectControl, _Component);

  _createClass(SelectControl, null, [{
    key: "getInitialState",
    value: function getInitialState() {
      return {
        isExpanded: false,
        isFocused: false,
        query: ''
      };
    }
  }]);

  function SelectControl(props) {
    var _this;

    _classCallCheck(this, SelectControl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectControl).call(this, props));
    _this.state = _objectSpread({}, _this.constructor.getInitialState(), {
      filteredOptions: [],
      selectedIndex: 0
    });
    _this.bindNode = _this.bindNode.bind(_assertThisInitialized(_this));
    _this.decrementSelectedIndex = _this.decrementSelectedIndex.bind(_assertThisInitialized(_this));
    _this.incrementSelectedIndex = _this.incrementSelectedIndex.bind(_assertThisInitialized(_this));
    _this.onAutofillChange = _this.onAutofillChange.bind(_assertThisInitialized(_this));
    _this.search = _this.search.bind(_assertThisInitialized(_this));
    _this.selectOption = _this.selectOption.bind(_assertThisInitialized(_this));
    _this.setExpanded = _this.setExpanded.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SelectControl, [{
    key: "bindNode",
    value: function bindNode(node) {
      this.node = node;
    }
  }, {
    key: "reset",
    value: function reset() {
      var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelected();
      var multiple = this.props.multiple;
      var initialState = this.constructor.getInitialState(); // Reset to the option label if not using tags.

      if (!multiple && selected.length && selected[0].label) {
        initialState.query = selected[0].label;
      }

      this.setState(initialState);
    }
  }, {
    key: "handleFocusOutside",
    value: function handleFocusOutside() {
      this.reset();
    }
  }, {
    key: "hasTags",
    value: function hasTags() {
      var _this$props = this.props,
          multiple = _this$props.multiple,
          selected = _this$props.selected;

      if (!multiple) {
        return false;
      }

      return selected.some(function (item) {
        return Boolean(item.label);
      });
    }
  }, {
    key: "getSelected",
    value: function getSelected() {
      var _this$props2 = this.props,
          multiple = _this$props2.multiple,
          options = _this$props2.options,
          selected = _this$props2.selected; // Return the passed value if an array is provided.

      if (multiple || Array.isArray(selected)) {
        return selected;
      }

      var selectedOption = options.find(function (option) {
        return option.key === selected;
      });
      return selectedOption ? [selectedOption] : [];
    }
  }, {
    key: "selectOption",
    value: function selectOption(option) {
      var _this$props3 = this.props,
          multiple = _this$props3.multiple,
          onChange = _this$props3.onChange,
          selected = _this$props3.selected;
      var query = this.state.query;
      var newSelected = multiple ? [].concat(_toConsumableArray(selected), [option]) : [option];
      this.reset(newSelected); // Trigger a change if the selected value is different and pass back
      // an array or string depending on the original value.

      if (Array.isArray(selected)) {
        var isSelected = findIndex(selected, {
          key: option.key
        });

        if (-1 === isSelected) {
          onChange(newSelected, query);
        }
      } else if (selected !== option.key) {
        onChange(option.key, query);
      }
    }
  }, {
    key: "decrementSelectedIndex",
    value: function decrementSelectedIndex() {
      var selectedIndex = this.state.selectedIndex;
      var options = this.getOptions();
      var nextSelectedIndex = null !== selectedIndex ? (selectedIndex === 0 ? options.length : selectedIndex) - 1 : options.length - 1;
      this.setState({
        selectedIndex: nextSelectedIndex
      });
    }
  }, {
    key: "incrementSelectedIndex",
    value: function incrementSelectedIndex() {
      var selectedIndex = this.state.selectedIndex;
      var options = this.getOptions();
      var nextSelectedIndex = null !== selectedIndex ? (selectedIndex + 1) % options.length : 0;
      this.setState({
        selectedIndex: nextSelectedIndex
      });
    }
  }, {
    key: "announce",
    value: function announce(filteredOptions) {
      var debouncedSpeak = this.props.debouncedSpeak;

      if (!debouncedSpeak) {
        return;
      }

      if (!!filteredOptions.length) {
        debouncedSpeak(sprintf(_n('%d result found, use up and down arrow keys to navigate.', '%d results found, use up and down arrow keys to navigate.', filteredOptions.length, 'woocommerce-admin'), filteredOptions.length), 'assertive');
      } else {
        debouncedSpeak(__('No results.', 'woocommerce-admin'), 'assertive');
      }
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var _this$props4 = this.props,
          isSearchable = _this$props4.isSearchable,
          options = _this$props4.options;
      var filteredOptions = this.state.filteredOptions;
      return isSearchable ? filteredOptions : options;
    }
  }, {
    key: "getFilteredOptions",
    value: function getFilteredOptions(options, query) {
      var _this$props5 = this.props,
          excludeSelectedOptions = _this$props5.excludeSelectedOptions,
          getSearchExpression = _this$props5.getSearchExpression,
          maxResults = _this$props5.maxResults,
          onFilter = _this$props5.onFilter;
      var selectedKeys = this.getSelected().map(function (option) {
        return option.key;
      });
      var filtered = []; // Create a regular expression to filter the options.

      var expression = getSearchExpression(escapeRegExp(query ? query.trim() : ''));
      var search = expression ? new RegExp(expression, 'i') : /^$/;

      for (var i = 0; i < options.length; i++) {
        var option = options[i];

        if (excludeSelectedOptions && selectedKeys.includes(option.key)) {
          continue;
        } // Merge label into keywords


        var _option$keywords = option.keywords,
            keywords = _option$keywords === void 0 ? [] : _option$keywords;

        if ('string' === typeof option.label) {
          keywords = [].concat(_toConsumableArray(keywords), [option.label]);
        }

        var isMatch = keywords.some(function (keyword) {
          return search.test(keyword);
        });

        if (!isMatch) {
          continue;
        }

        filtered.push(option); // Abort early if max reached

        if (maxResults && filtered.length === maxResults) {
          break;
        }
      }

      return onFilter(filtered, query);
    }
  }, {
    key: "setExpanded",
    value: function setExpanded(value) {
      this.setState({
        isExpanded: value
      });
    }
  }, {
    key: "search",
    value: function search(query) {
      var _this2 = this;

      var _this$props6 = this.props,
          hideBeforeSearch = _this$props6.hideBeforeSearch,
          onSearch = _this$props6.onSearch,
          options = _this$props6.options;
      this.setState({
        query: query,
        isFocused: true
      });
      var promise = this.activePromise = Promise.resolve(onSearch(options, query)).then(function (searchOptions) {
        if (promise !== _this2.activePromise) {
          // Another promise has become active since this one was asked to resolve, so do nothing,
          // or else we might end triggering a race condition updating the state.
          return;
        } // Get all options if `hideBeforeSearch` is enabled and query is not null.


        var filteredOptions = null !== query && !query.length && !hideBeforeSearch ? searchOptions : _this2.getFilteredOptions(searchOptions, query);

        _this2.setState({
          selectedIndex: 0,
          filteredOptions: filteredOptions,
          isExpanded: Boolean(filteredOptions.length)
        }, function () {
          return _this2.announce(filteredOptions);
        });
      });
    }
  }, {
    key: "onAutofillChange",
    value: function onAutofillChange(event) {
      var options = this.props.options;
      var filteredOptions = this.getFilteredOptions(options, event.target.value);

      if (1 === filteredOptions.length) {
        this.selectOption(filteredOptions[0]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          autofill = _this$props7.autofill,
          children = _this$props7.children,
          className = _this$props7.className,
          inlineTags = _this$props7.inlineTags,
          instanceId = _this$props7.instanceId,
          isSearchable = _this$props7.isSearchable,
          options = _this$props7.options;
      var _this$state = this.state,
          isExpanded = _this$state.isExpanded,
          isFocused = _this$state.isFocused,
          selectedIndex = _this$state.selectedIndex;
      var hasTags = this.hasTags();

      var _ref = options[selectedIndex] || {},
          _ref$key = _ref.key,
          selectedKey = _ref$key === void 0 ? '' : _ref$key;

      var listboxId = isExpanded ? "woocommerce-select-control__listbox-".concat(instanceId) : null;
      var activeId = isExpanded ? "woocommerce-select-control__option-".concat(instanceId, "-").concat(selectedKey) : null;
      return createElement("div", {
        className: classnames('woocommerce-select-control', className, {
          'has-inline-tags': hasTags && inlineTags,
          'is-focused': isFocused,
          'is-searchable': isSearchable
        }),
        ref: this.bindNode
      }, autofill && createElement("input", {
        onChange: this.onAutofillChange,
        name: autofill,
        type: "text",
        className: "woocommerce-select-control__autofill-input",
        tabIndex: "-1"
      }), children, createElement(Control, _extends({}, this.props, this.state, {
        activeId: activeId,
        hasTags: hasTags,
        isExpanded: isExpanded,
        listboxId: listboxId,
        onSearch: this.search,
        selected: this.getSelected(),
        setExpanded: this.setExpanded,
        decrementSelectedIndex: this.decrementSelectedIndex,
        incrementSelectedIndex: this.incrementSelectedIndex
      })), !inlineTags && hasTags && createElement(Tags, _extends({}, this.props, {
        selected: this.getSelected()
      })), isExpanded && createElement(List, _extends({}, this.props, this.state, {
        activeId: activeId,
        listboxId: listboxId,
        node: this.node,
        onSelect: this.selectOption,
        onSearch: this.search,
        options: this.getOptions(),
        decrementSelectedIndex: this.decrementSelectedIndex,
        incrementSelectedIndex: this.incrementSelectedIndex,
        setExpanded: this.setExpanded
      })));
    }
  }]);

  return SelectControl;
}(Component);
SelectControl.propTypes = {
  /**
   * Name to use for the autofill field, not used if no string is passed.
   */
  autofill: PropTypes.string,

  /**
   * A renderable component (or string) which will be displayed before the `Control` of this component.
   */
  children: PropTypes.node,

  /**
   * Class name applied to parent div.
   */
  className: PropTypes.string,

  /**
   * Exclude already selected options from the options list.
   */
  excludeSelectedOptions: PropTypes.bool,

  /**
   * Add or remove items to the list of options after filtering,
   * passed the array of filtered options and should return an array of options.
   */
  onFilter: PropTypes.func,

  /**
   * Function to add regex expression to the filter the results, passed the search query.
   */
  getSearchExpression: PropTypes.func,

  /**
   * Help text to be appended beneath the input.
   */
  help: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /**
   * Render tags inside input, otherwise render below input.
   */
  inlineTags: PropTypes.bool,

  /**
   * Allow the select options to be filtered by search input.
   */
  isSearchable: PropTypes.bool,

  /**
   * A label to use for the main input.
   */
  label: PropTypes.string,

  /**
   * Function called when selected results change, passed result list.
   */
  onChange: PropTypes.func,

  /**
   * Function run after search query is updated, passed previousOptions and query,
   * should return a promise with an array of updated options.
   */
  onSearch: PropTypes.func,

  /**
   * An array of objects for the options list.  The option along with its key, label and
   * value will be returned in the onChange event.
   */
  options: PropTypes.arrayOf(PropTypes.shape({
    isDisabled: PropTypes.bool,
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    keywords: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    value: PropTypes.any
  })).isRequired,

  /**
   * A placeholder for the search input.
   */
  placeholder: PropTypes.string,

  /**
   * An array of objects describing selected values or optionally a string for a single value.
   * If the label of the selected value is omitted, the Tag of that value will not
   * be rendered inside the search box.
   */
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    label: PropTypes.string
  }))]),

  /**
   * A limit for the number of results shown in the options menu.  Set to 0 for no limit.
   */
  maxResults: PropTypes.number,

  /**
   * Allow multiple option selections.
   */
  multiple: PropTypes.bool,

  /**
   * Render a 'Clear' button next to the input box to remove its contents.
   */
  showClearButton: PropTypes.bool,

  /**
   * The input type for the search box control.
   */
  searchInputType: PropTypes.oneOf(['text', 'search', 'number', 'email', 'tel', 'url']),

  /**
   * Only show list options after typing a search query.
   */
  hideBeforeSearch: PropTypes.bool,

  /**
   * Render results list positioned statically instead of absolutely.
   */
  staticList: PropTypes.bool
};
SelectControl.defaultProps = {
  autofill: null,
  excludeSelectedOptions: true,
  getSearchExpression: identity,
  inlineTags: false,
  isSearchable: false,
  onChange: noop,
  onFilter: identity,
  onSearch: function onSearch(options) {
    return Promise.resolve(options);
  },
  maxResults: 0,
  multiple: false,
  searchInputType: 'search',
  selected: [],
  showClearButton: false,
  hideBeforeSearch: false,
  staticList: false
};
export default compose([withSpokenMessages, withInstanceId, withFocusOutside // this MUST be the innermost HOC as it calls handleFocusOutside
])(SelectControl);
//# sourceMappingURL=index.js.map